module.exports = __webpack_public_path__ + "img/right.1f575014.png";